import { RolePermissionsPlugin } from './role-permissions-plugin';

export default RolePermissionsPlugin;
